import React from "react";
import PropTypes from "prop-types";

export function EmptyPageContent(props) {

  return (
    <div className="account-page__empty">
      <div className="account-page__empty-glyph-circle">
        <div className={props.glyph}/>
      </div>
      <h2 className="account-page__empty-title">
        {props.title}
      </h2>
      <p className="account-page__empty-text">
        {props.text}
      </p>
      {props.link && (
        <a href={props.link.url} className="account-page__empty-link">
          {props.link.text}
          <span className="glyph-core-square-arrow-up-right"/>
        </a>
      )}
    </div>
  );
}

EmptyPageContent.propTypes = {
  glyph: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  link: PropTypes.shape({
    url: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  }),
};